import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

//Import Images
import AboutImage from "../../../assets/images/about/img-about.png";

const About = () => {
    return (
        <React.Fragment>
            <section className="section overflow-hidden">
                <Container>
                    <Row className="align-items-center g-0">
                        <Col lg={7}>
                            <div className="section-title me-lg-5">
                                <h6 className="sub-title">About Matrix Executive Search Group</h6>
                                <h2 className="title mb-4">
                                    Why We<span className="text-warning fw-bold">  Exist</span>{" "}
                                </h2>
                                <p className="text-muted">
                                    At Matrix Executive Search Group, we believe the right people are the driving force behind great
                                    companies—and that meaningful work transforms lives.
                                    Our mission is simple but powerful: to connect exceptional talent with visionary
                                    organizations so both can grow and thrive.
                                    We’re not just filling roles—we’re aligning people with purpose, and careers with culture.
                                </p>
                                <p className="text-muted">
                                    Whether you're launching your career or hiring top talent, our commitment to quality, transparency, and innovation sets us apart in the competitive job market.
                                </p>
                                <Row className="mt-4 pt-2">
                                    <Col md={12}>
                                        <ul className="list-unstyled about-list text-muted mb-0 mb-md-3">
                                            <li> Fast and user-friendly job search experience.</li>
                                            <li> Verified and quality job postings only.</li>
                                            <li> Real-time job alerts tailored to your profile.</li>
                                            <li> Secure and private candidate profiles.</li>
                                            <li> Dedicated customer support for users.</li>
                                            <li> Smart filtering to match jobs more accurately.</li>
                                            <li> Thousands of successful job placements.</li>
                                        </ul>
                                    </Col>
                                    {/* <Col md={6}>
                                        <ul className="list-unstyled about-list text-muted">
                                            <li> Create Resume</li>
                                            <li> 5000+ Comnpanies</li>
                                            <li> Our Blog</li>
                                            <li> and more...</li>
                                        </ul>
                                    </Col> */}
                                </Row>
                                <div className="mt-3">
                                    <Link to="/contact-us" className="btn btn-primary btn-hover">
                                        Contact Us
                                        {" "}
                                        <i className="uil uil-angle-right-b align-middle"></i>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <div className="about-img mt-4 mt-lg-0" style={{ width: '100%' }}>
                                <img src={AboutImage} alt="" className="img-fluid rounded" style={{ width: '100%', height: '600px', objectFit: 'cover' }} draggable={false} />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default About;
